import axios from 'axios';

export interface CepData {
  cep: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  service: string;
}

export interface AddressData {
  street: string;
  district: string;
  city: string;
  state: string;
  complement: string;
}

export class CepService {
  private static readonly BASE_URL = 'https://brasilapi.com.br/api/cep/v1';

  static async fetchAddressByCep(cep: string): Promise<AddressData | null> {
    // Remove caracteres não numéricos
    const cleanCep = cep.replace(/\D/g, '');
    
    if (cleanCep.length !== 8) {
      throw new Error('CEP deve conter 8 dígitos');
    }

    try {
      const response = await axios.get(`${this.BASE_URL}/${cleanCep}`);
      
      const data: CepData = response.data;      
      const street = {
        street: data.street || '',
        district: data.neighborhood || '',
        city: data.city || '',
        state: data.state || '',
        complement: ''
      };
      return street;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        throw new Error('CEP não encontrado');
      }
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('Erro inesperado ao consultar CEP');
    }
  }

  static validateCepFormat(cep: string): boolean {
    const cleanCep = cep.replace(/\D/g, '');
    return cleanCep.length === 8;
  }
}
